import { createStore } from 'jotai';

export const novelStore: ReturnType<typeof createStore> = createStore();
export * from 'jotai';
